var api = require("!./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!./node_modules/css-loader/dist/cjs.js??ref--2-oneOf-0-0!./node_modules/postcss-loader/dist/cjs.js??ref--3-0!./node_modules/windicss-webpack-plugin/dist/loaders/virtual-module.cjs!./virtual:windi.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};